import { signal, computed, Injectable } from '@angular/core';

import { type Profile } from '@entities/profile';

@Injectable({
  providedIn: 'root',
})
export class AuthStore {
  private readonly _profile = signal<Profile | null>(null);

  public readonly profile = this._profile.asReadonly();

  public readonly requireProfile = computed(() => {
    const profile = this._profile();
    if (!profile) {
      throw new Error('Profile is not loaded. Make sure the user is authenticated.');
    }

    return profile;
  });

  public readonly fullName = computed(() => {
    const profile = this.requireProfile();
    return `${profile.firstName} ${profile.lastName}`;
  });

  public setGuest(): void {
    this._profile.set(null);
  }

  public setProfile(profile: Profile): void {
    this._profile.set(profile);
  }
}
